import { render, staticRenderFns } from "./unionInfo.vue?vue&type=template&id=55be8332&scoped=true&"
import script from "./unionInfo.vue?vue&type=script&lang=js&"
export * from "./unionInfo.vue?vue&type=script&lang=js&"
import style0 from "./unionInfo.vue?vue&type=style&index=0&id=55be8332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be8332",
  null
  
)

export default component.exports